import { render, staticRenderFns } from "./ImagePlacement.vue?vue&type=template&id=243a2c3b&scoped=true"
import script from "./ImagePlacement.vue?vue&type=script&lang=js"
export * from "./ImagePlacement.vue?vue&type=script&lang=js"
import style0 from "./ImagePlacement.vue?vue&type=style&index=0&id=243a2c3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a2c3b",
  null
  
)

export default component.exports